<template>
  <SimCardProfileGroup />
</template>

<script>
import SimCardProfileGroup from './SimCardProfileGroup/SimCardProfileGroup.vue'
export default {
  components: {
    SimCardProfileGroup
  }
}
</script>

<style scoped>

</style>
